var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.71429 6.42888V3.71444C8.71429 2.08578 7.42857 1 5.5 1C3.57143 1 2.28571 2.08578 2.28571 3.71444V6.42888M5.5 8.60043V10.772M5.5 12.9435C3.01472 12.9435 1 11.2421 1 9.14331C1 7.04451 3.01472 5.3431 5.5 5.3431C7.98528 5.3431 10 7.04451 10 9.14331C10 11.2421 7.98528 12.9435 5.5 12.9435ZM5.5 9.14331C5.14496 9.14331 4.85714 8.90025 4.85714 8.60043C4.85714 8.3006 5.14496 8.05754 5.5 8.05754C5.85504 8.05754 6.14286 8.3006 6.14286 8.60043C6.14286 8.90025 5.85504 9.14331 5.5 9.14331Z",
    stroke: "#5E5E5E",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.645f74f5.svg";
export { ForwardRef as ReactComponent };